import NovidadesAdminLista from "@/modules/Novidades/pages/AdminIndex";
import NovidadesAdminForm from "@/modules/Novidades/pages/AdminForm";
import NovidadesHistorico from "@/modules/Novidades/pages/Historico";

export default [
  {
    name: "novidadesAdmin",
    path: "/admin/novidades",
    component: NovidadesAdminLista,
    meta: { title: "Central de Novidades", permission: "admin/novidades" },
  },
  {
    name: "novidadesAdminNovo",
    path: "/admin/novidades/novo",
    component: NovidadesAdminForm,
    meta: { title: "Central de Novidades - Novo Pacote", permission: "admin/novidades" },
  },
  {
    name: "novidadesAdminEditar",
    path: "/admin/novidades/:id/editar",
    component: NovidadesAdminForm,
    meta: { title: "Central de Novidades - Editar Pacote", permission: "admin/novidades" },
  },
  {
    name: "novidadesHistorico",
    path: "/novidades",
    component: NovidadesHistorico,
    meta: { title: "Novidades do Sistema" },
  },
];
